var map = {
	"./anim/content-loader.svg": "4084",
	"./anim/dots-loader.svg": "04bd",
	"./anim/gooey-ring-loader.svg": "d305",
	"./business-guide/icon-concept.svg": "235d",
	"./business-guide/icon-projections.svg": "26bf",
	"./business-guide/icon-research.svg": "e3e8",
	"./business-guide/icon-setup.svg": "653a",
	"./business-guide/status-false.svg": "a4fb",
	"./business-guide/status-true.svg": "8031",
	"./icons/account-settings-icons/change-billing.svg": "9989",
	"./icons/account-settings-icons/collection.svg": "a725",
	"./icons/account-settings-icons/log-out.svg": "8902",
	"./icons/account-settings-icons/my-profile.svg": "e942",
	"./icons/account-settings-icons/payment-details.svg": "1757",
	"./icons/account-settings-icons/plans-and-upgrades.svg": "ead0",
	"./icons/account-settings-icons/refer-a-friend.svg": "67be",
	"./icons/account-settings-icons/users-and-members.svg": "cd05",
	"./icons/add-dialog-folder.svg": "0223",
	"./icons/add-group-icon.svg": "0f86",
	"./icons/add-user-icon.svg": "b83b",
	"./icons/back-arrow.svg": "5573",
	"./icons/beauty-and-wellness-icon.svg": "b3ebc",
	"./icons/burden-settings-icon.svg": "12c0",
	"./icons/bus-colored-icon - Copy.svg": "f491",
	"./icons/bus-colored-icon.svg": "995b",
	"./icons/business-plan-icon.svg": "b005",
	"./icons/business-services-icon.svg": "434e",
	"./icons/caret-down.svg": "d2ce",
	"./icons/caret.svg": "bcecd",
	"./icons/catalogue-icon.svg": "d1f6",
	"./icons/champagne-colored-icon.svg": "1f4e",
	"./icons/charts/facilities-costs.svg": "2081",
	"./icons/check-mark.svg": "1408",
	"./icons/checked-blue.svg": "495e",
	"./icons/checked-colored-icon.svg": "2b79",
	"./icons/checked-icon-disabled.svg": "5e1b",
	"./icons/checked-icon.svg": "a0bc",
	"./icons/checkmark-colored-icon.svg": "06aa",
	"./icons/clap-bordered-colored-icon.svg": "1dab",
	"./icons/clap-colored-icon.svg": "01a9",
	"./icons/coffee-colored-icon.svg": "14631",
	"./icons/collection-icon.svg": "c6a3",
	"./icons/constuction-icon.svg": "4d87",
	"./icons/controls-icon.svg": "05ab",
	"./icons/curved-arrow-icon.svg": "51ef",
	"./icons/dancing-colored-icon.svg": "3715",
	"./icons/direct-costs-icon.svg": "7330",
	"./icons/drag-sorting-icon.svg": "afb8",
	"./icons/dropdowns/checked-icon.svg": "78a0",
	"./icons/dropdowns/concept/distribution.svg": "c0c0",
	"./icons/dropdowns/concept/idea.svg": "fe21",
	"./icons/dropdowns/concept/partners.svg": "5619",
	"./icons/dropdowns/concept/product.svg": "35bc",
	"./icons/dropdowns/concept/promotion.svg": "f910",
	"./icons/dropdowns/concept/testing.svg": "6def",
	"./icons/dropdowns/dashboard.svg": "451d",
	"./icons/dropdowns/expenses.svg": "9051",
	"./icons/dropdowns/forecast/direct-costs.svg": "2c63",
	"./icons/dropdowns/forecast/industry-standards.svg": "54c5c",
	"./icons/dropdowns/forecast/marketing-budget.svg": "b698",
	"./icons/dropdowns/forecast/other-overheads.svg": "4d29",
	"./icons/dropdowns/forecast/profit-and-cash-flow.svg": "95a5",
	"./icons/dropdowns/forecast/revenue-streams.svg": "798b",
	"./icons/dropdowns/research/comparison.svg": "98ca",
	"./icons/dropdowns/research/competitors.svg": "309e",
	"./icons/dropdowns/research/customers.svg": "b742",
	"./icons/dropdowns/research/market-potential.svg": "1bb9",
	"./icons/dropdowns/research/market.svg": "43a0",
	"./icons/dropdowns/research/swot-analysis.svg": "e1ba",
	"./icons/dropdowns/set-up/checklist.svg": "4053",
	"./icons/dropdowns/set-up/financing.svg": "c17b",
	"./icons/dropdowns/set-up/management-team.svg": "8983",
	"./icons/dropdowns/set-up/ownership.svg": "0eb8",
	"./icons/dropdowns/set-up/staff-and-payroll.svg": "80ee",
	"./icons/dropdowns/set-up/startup-costs.svg": "2d5f",
	"./icons/dropdowns/settings.svg": "15d7",
	"./icons/dropdowns/total-costs.svg": "4492",
	"./icons/dropdowns/validation/idea-score.svg": "e214",
	"./icons/edit-icon.svg": "2ed7",
	"./icons/education-and-training-icon.svg": "0229",
	"./icons/entratainment-and-showbiz-icon.svg": "2b4c",
	"./icons/external-icon.svg": "9cfd",
	"./icons/farming-mining-and-construction-icon.svg": "4ced",
	"./icons/feather-icon.svg": "131e",
	"./icons/features/business-guideIcon.svg": "b96a",
	"./icons/features/business-planIcon.svg": "e5ff",
	"./icons/features/financial-planIcon.svg": "7355",
	"./icons/features/idea-planIcon.svg": "7a54",
	"./icons/features/idea-validationIcon.svg": "da6d",
	"./icons/features/whiteboardIcon.svg": "9571",
	"./icons/financing-dropdown/crowdfunding-circle.svg": "788a",
	"./icons/financing-dropdown/crowdfunding.svg": "8771",
	"./icons/financing-dropdown/investment-circle.svg": "b122",
	"./icons/financing-dropdown/investment.svg": "8b93",
	"./icons/financing-dropdown/line-of-credit-circle.svg": "36b0",
	"./icons/financing-dropdown/line-of-credit.svg": "22f0",
	"./icons/financing-dropdown/loan-circle.svg": "8280",
	"./icons/financing-dropdown/loan.svg": "f5d1",
	"./icons/financing-dropdown/savings-circle.svg": "fcc6",
	"./icons/financing-dropdown/savings.svg": "e1ec",
	"./icons/fitness-and-recreation-icon.svg": "db86",
	"./icons/food-and-drinking-icon.svg": "54c7",
	"./icons/four-squares-icon.svg": "84bf",
	"./icons/frown-icon.svg": "8982",
	"./icons/frown-red-icon.svg": "9974",
	"./icons/gears-icon-2.svg": "b221",
	"./icons/gears-icon.svg": "52b6",
	"./icons/gears-icons.svg": "3f0b",
	"./icons/guide-icon.svg": "60e9",
	"./icons/health-icon.svg": "3b11",
	"./icons/heart-icon.svg": "bcf6",
	"./icons/home-business-icon.svg": "8b32",
	"./icons/home-icon.svg": "5654",
	"./icons/hotels-and-accommodation-icon.svg": "a206",
	"./icons/icon-search.svg": "c755",
	"./icons/idea-edit-icon.svg": "f9f7",
	"./icons/idea-plan/avatar-icon-circle.svg": "c444",
	"./icons/idea-plan/competitors-icon.svg": "cb25",
	"./icons/idea-plan/customers-icon.svg": "a019",
	"./icons/idea-plan/delete-icon-full.svg": "fe15",
	"./icons/idea-plan/delete-icon.svg": "2abc",
	"./icons/idea-plan/delete-note-icon.svg": "a525",
	"./icons/idea-plan/distribution-icon.svg": "6ba9",
	"./icons/idea-plan/document-colored-icon.svg": "c5b5",
	"./icons/idea-plan/download-icon.svg": "7bf8",
	"./icons/idea-plan/edit-note-icon.svg": "dcbf",
	"./icons/idea-plan/erase-icon.svg": "3e77",
	"./icons/idea-plan/financing-icon.svg": "edfd",
	"./icons/idea-plan/initial-investment-icon.svg": "2a92",
	"./icons/idea-plan/kanta-icon.svg": "0bd0",
	"./icons/idea-plan/market-icon.svg": "b643",
	"./icons/idea-plan/partners-icon.svg": "3894",
	"./icons/idea-plan/print-icon.svg": "1d99",
	"./icons/idea-plan/product-icon.svg": "1536",
	"./icons/idea-plan/promotion-icon.svg": "f601",
	"./icons/idea-plan/remove-colored-icon.svg": "30f9",
	"./icons/idea-plan/revenue-streams-icon.svg": "ae86",
	"./icons/idea-plan/running-costs-icon.svg": "3815",
	"./icons/idea-plan/share-icon.svg": "3903",
	"./icons/idea-plan/team-icon.svg": "b66d",
	"./icons/idea-plan/what-icon.svg": "539c6",
	"./icons/idea-plan/why-icon.svg": "7ac7",
	"./icons/idea-score.svg": "7cb1",
	"./icons/idea-settings/from-scratch.svg": "6b52",
	"./icons/idea-settings/use-template.svg": "5956",
	"./icons/image-icon.svg": "d06f",
	"./icons/info-icon-small.svg": "12dd",
	"./icons/info-icon.svg": "7701",
	"./icons/jodit-image.svg": "cce2",
	"./icons/journal-icon.svg": "dc9e",
	"./icons/journal/add-file.svg": "4cf3",
	"./icons/journal/add-section-icon.svg": "1007",
	"./icons/journal/cover-page-icon.svg": "7d0e",
	"./icons/journal/distribution-icon.svg": "7ea7",
	"./icons/journal/document-add-outlined-symbol.svg": "d6dd",
	"./icons/journal/document-icon.svg": "2c45",
	"./icons/journal/goals-icon.svg": "28d9",
	"./icons/journal/idea-icon.svg": "1fd1",
	"./icons/journal/partners-icon.svg": "cd46",
	"./icons/journal/product-icon.svg": "95d9",
	"./icons/journal/promotion-icon.svg": "e46d",
	"./icons/journal/testing-icon.svg": "6a30",
	"./icons/junction-icon.svg": "b7c1",
	"./icons/labor-guide-icon.svg": "1aee",
	"./icons/left-quote.svg": "c1b7",
	"./icons/lightbulb.svg": "8314",
	"./icons/link/link-icon.svg": "e8fc",
	"./icons/locked-padlock.svg": "401e",
	"./icons/man-icon.svg": "f9df",
	"./icons/management-team-icon-in-circle.svg": "a8eb",
	"./icons/management-team-icon.svg": "d232",
	"./icons/manufacturing-icon.svg": "184d",
	"./icons/marketing-budget-icon.svg": "d1de",
	"./icons/menu-button-of-three-lines.svg": "8974",
	"./icons/notification-bell.svg": "4c73",
	"./icons/one-page-plan-icon.svg": "5aea",
	"./icons/other-icon.svg": "ee42",
	"./icons/other-overheads-icon.svg": "20ca",
	"./icons/other-overheads/accounting.svg": "8860a",
	"./icons/other-overheads/dues-and-subs.svg": "81f67",
	"./icons/other-overheads/kalkulator.svg": "a9b7",
	"./icons/other-overheads/office-supplies.svg": "990e",
	"./icons/other-overheads/overheads-accounting.svg": "f92b",
	"./icons/other-overheads/overheads-dues-and-subscriptions.svg": "357e",
	"./icons/other-overheads/overheads-office-supplies.svg": "87ee",
	"./icons/other-overheads/overheads-product-development.svg": "bc24",
	"./icons/other-overheads/overheads-rental-cost.svg": "35cd",
	"./icons/other-overheads/overheads-repair-and-maintenatce.svg": "f3e4",
	"./icons/other-overheads/overheads-representation.svg": "a49d",
	"./icons/other-overheads/overheads-sales-expenses.svg": "0d13",
	"./icons/other-overheads/overheads-taxes.svg": "12b2",
	"./icons/other-overheads/overheads-telephone-and-internet.svg": "a188",
	"./icons/other-overheads/overheads-travelling.svg": "6d4f",
	"./icons/other-overheads/overheads-utilities.svg": "1b5d",
	"./icons/other-overheads/overheads-web-hosting.svg": "7ebb",
	"./icons/other-overheads/product-development.svg": "2c37",
	"./icons/other-overheads/rental-cost.svg": "6e56",
	"./icons/other-overheads/repair-and-maintenatce.svg": "1d13",
	"./icons/other-overheads/representation.svg": "926f",
	"./icons/other-overheads/sales-expenses.svg": "60f7",
	"./icons/other-overheads/taxes-and-legal.svg": "645a",
	"./icons/other-overheads/telephone-and-internet.svg": "f4d7",
	"./icons/other-overheads/travelling.svg": "03c7",
	"./icons/other-overheads/utilities.svg": "94f8",
	"./icons/other-overheads/web-hosting.svg": "06af",
	"./icons/overview-icon.svg": "bb98",
	"./icons/overview-icons/net-profit-icon.svg": "e6ce",
	"./icons/overview-icons/total-costs-icon.svg": "b573",
	"./icons/overview-icons/total-revenue-icon.svg": "408ca",
	"./icons/pen-icon-blue.svg": "2292c",
	"./icons/pen-icon-gray.svg": "efba",
	"./icons/pen-icon-red.svg": "ac8b",
	"./icons/pen-icon.svg": "32e6",
	"./icons/personal-services-icon.svg": "f1d8",
	"./icons/pitch-deck-icon.svg": "658d",
	"./icons/planet-icon.svg": "f8fc",
	"./icons/play-icon.svg": "e089",
	"./icons/plus-in-circle-icon.svg": "f1b1",
	"./icons/product-icon.svg": "b141",
	"./icons/product-tour/businessGuide.svg": "ef56",
	"./icons/product-tour/businessPlan.svg": "7844",
	"./icons/product-tour/financialPlan.svg": "6176",
	"./icons/product-tour/ideaPlan.svg": "bfab",
	"./icons/product-tour/validation.svg": "e39c",
	"./icons/product-tour/whiteboard.svg": "da3a",
	"./icons/professional-services-icon.svg": "ef03",
	"./icons/profile-icon.svg": "f643",
	"./icons/project-icon.svg": "97d4",
	"./icons/reatil-trade-icon.svg": "d80e",
	"./icons/repair-and-maintenance-icon.svg": "18de",
	"./icons/revenue-stream-dropdown/billable-rate-circle.svg": "25b9",
	"./icons/revenue-stream-dropdown/billable-rate-icon.svg": "2aee",
	"./icons/revenue-stream-dropdown/occupancy-rate-circle.svg": "4f39",
	"./icons/revenue-stream-dropdown/occupancy-rate-icon.svg": "fb49",
	"./icons/revenue-stream-dropdown/product-circle.svg": "4407",
	"./icons/revenue-stream-dropdown/product-icon.svg": "c67e",
	"./icons/revenue-stream-dropdown/recurring-charges-circle.svg": "8c913",
	"./icons/revenue-stream-dropdown/recurring-charges-icon.svg": "5cf2",
	"./icons/revenue-stream-dropdown/service-circle.svg": "7bf2",
	"./icons/revenue-stream-dropdown/service-icon.svg": "8fd0",
	"./icons/revenue-streams-icon.svg": "62fb",
	"./icons/satisfied-colored-icon.svg": "dcb7",
	"./icons/save-icon.svg": "399c",
	"./icons/savings-icon.svg": "a2f6",
	"./icons/set-up-equipment.svg": "d360",
	"./icons/set-up-facilities.svg": "89f2",
	"./icons/set-up-initial-promotion.svg": "3d72",
	"./icons/set-up-inventory.svg": "5b3d",
	"./icons/set-up-miscellaneous.svg": "121e",
	"./icons/shield-icon.svg": "22bd",
	"./icons/sidebar-icons/business-plan.svg": "d3ec",
	"./icons/sidebar-icons/collection.svg": "4fd0",
	"./icons/sidebar-icons/controls.svg": "4d94",
	"./icons/sidebar-icons/copy.svg": "02b1",
	"./icons/sidebar-icons/filled/business-plan.svg": "df7cd",
	"./icons/sidebar-icons/filled/collection.svg": "17a5",
	"./icons/sidebar-icons/filled/home.svg": "b66d4",
	"./icons/sidebar-icons/filled/idea-score.svg": "2ff1",
	"./icons/sidebar-icons/filled/journal.svg": "a519",
	"./icons/sidebar-icons/filled/one-page-plan.svg": "d900",
	"./icons/sidebar-icons/filled/overwiev.svg": "792a",
	"./icons/sidebar-icons/filled/pitch-deck.svg": "7023",
	"./icons/sidebar-icons/filled/star.svg": "bd1b",
	"./icons/sidebar-icons/filled/story-mode.svg": "7c0a",
	"./icons/sidebar-icons/filled/track-results.svg": "a6cd",
	"./icons/sidebar-icons/financials.svg": "9719",
	"./icons/sidebar-icons/gallery.svg": "4fb0",
	"./icons/sidebar-icons/home.svg": "d586",
	"./icons/sidebar-icons/idea-score.svg": "51202",
	"./icons/sidebar-icons/idea.svg": "3fc6",
	"./icons/sidebar-icons/journal.svg": "1a83",
	"./icons/sidebar-icons/light-bulb.svg": "737b",
	"./icons/sidebar-icons/light-bulb2.svg": "c3c3",
	"./icons/sidebar-icons/light-bulb3.svg": "4293",
	"./icons/sidebar-icons/light-on.svg": "e9ea",
	"./icons/sidebar-icons/one-page-plan.svg": "d913d",
	"./icons/sidebar-icons/overview-icon.svg": "41a0",
	"./icons/sidebar-icons/overwiev.svg": "a786",
	"./icons/sidebar-icons/pitch-deck.svg": "7f6e",
	"./icons/sidebar-icons/star.svg": "2bf0",
	"./icons/sidebar-icons/story-mode.svg": "5f2f",
	"./icons/sidebar-icons/thinking.svg": "cd1e",
	"./icons/sidebar-icons/track-results.svg": "7091",
	"./icons/staff-group-icon.svg": "74e3",
	"./icons/star-colored-icon.svg": "c6d20",
	"./icons/star-icon.svg": "050b",
	"./icons/story-mode-icon.svg": "2128",
	"./icons/story-mode/checked.svg": "2d60",
	"./icons/story-mode/competitor.svg": "f10a",
	"./icons/story-mode/concept-icon.svg": "871d",
	"./icons/story-mode/customer.svg": "1bd6",
	"./icons/story-mode/delivery-truck.svg": "b406",
	"./icons/story-mode/dividends.svg": "2c95",
	"./icons/story-mode/gift.svg": "222a",
	"./icons/story-mode/horizontal.svg": "78c2",
	"./icons/story-mode/information.svg": "359d",
	"./icons/story-mode/market/growing-icon.svg": "221c",
	"./icons/story-mode/market/international-market-icon.svg": "a7ae",
	"./icons/story-mode/market/local-market-icon.svg": "53f0",
	"./icons/story-mode/market/national-market-icon.svg": "5bba",
	"./icons/story-mode/market/new-icon.svg": "aba3",
	"./icons/story-mode/market/regional-market-icon.svg": "be80",
	"./icons/story-mode/market/shrinking-icon.svg": "f1ac",
	"./icons/story-mode/market/stagnation-icon.svg": "1b92",
	"./icons/story-mode/marketing-budget/circle_digital marketing.svg": "4365",
	"./icons/story-mode/marketing-budget/circle_miscellaneous.svg": "a376",
	"./icons/story-mode/marketing-budget/circle_offline adv.svg": "0c8b",
	"./icons/story-mode/marketing-budget/circle_public relations.svg": "671c",
	"./icons/story-mode/marketing-budget/circle_social media.svg": "b28a",
	"./icons/story-mode/marketing-budget/w-digital-marketing.svg": "3052",
	"./icons/story-mode/marketing-budget/w-miscellaneous.svg": "2a88",
	"./icons/story-mode/marketing-budget/w-offline-adv.svg": "10d8",
	"./icons/story-mode/marketing-budget/w-public-relations.svg": "2e06",
	"./icons/story-mode/marketing-budget/w-soc-media.svg": "a00f",
	"./icons/story-mode/megaphone.svg": "299f",
	"./icons/story-mode/menu.svg": "3f26",
	"./icons/story-mode/moneybag.svg": "37ee",
	"./icons/story-mode/palette.svg": "8a93",
	"./icons/story-mode/people.svg": "0471",
	"./icons/story-mode/projections-icon.svg": "4a30",
	"./icons/story-mode/promotional-activities/brochures and flyers.svg": "8c03",
	"./icons/story-mode/promotional-activities/direct email.svg": "2705",
	"./icons/story-mode/promotional-activities/events.svg": "61bd",
	"./icons/story-mode/promotional-activities/facebook.svg": "30b2",
	"./icons/story-mode/promotional-activities/g-ads.svg": "302b",
	"./icons/story-mode/promotional-activities/instagram.svg": "8019",
	"./icons/story-mode/promotional-activities/other.svg": "e412",
	"./icons/story-mode/promotional-activities/outdoor.svg": "c6eb",
	"./icons/story-mode/promotional-activities/personal sales.svg": "aa00",
	"./icons/story-mode/promotional-activities/press.svg": "2e52",
	"./icons/story-mode/promotional-activities/public relations.svg": "0553",
	"./icons/story-mode/promotional-activities/sales promotion.svg": "acd5",
	"./icons/story-mode/promotional-activities/television.svg": "7250",
	"./icons/story-mode/promotional-activities/w-direct-mail.svg": "3bb1",
	"./icons/story-mode/promotional-activities/w-personal-sales.svg": "2fbe",
	"./icons/story-mode/promotional-activities/w-public-relations.svg": "a307",
	"./icons/story-mode/promotional-activities/w-sales-promotion.svg": "c29f",
	"./icons/story-mode/promotional-activities/w-word-of-mouth.svg": "1d3a",
	"./icons/story-mode/promotional-activities/w_brochure.svg": "8468",
	"./icons/story-mode/promotional-activities/w_events.svg": "0b40",
	"./icons/story-mode/promotional-activities/w_facebook.svg": "1af1",
	"./icons/story-mode/promotional-activities/w_google.svg": "2a28",
	"./icons/story-mode/promotional-activities/w_instagram.svg": "27f0",
	"./icons/story-mode/promotional-activities/w_other.svg": "b4a7",
	"./icons/story-mode/promotional-activities/w_outdoor.svg": "1956",
	"./icons/story-mode/promotional-activities/w_press.svg": "3ca8",
	"./icons/story-mode/promotional-activities/w_television.svg": "3304",
	"./icons/story-mode/promotional-activities/w_webpage.svg": "a536",
	"./icons/story-mode/promotional-activities/website.svg": "4d5f",
	"./icons/story-mode/promotional-activities/word of mouth.svg": "68dc",
	"./icons/story-mode/research-icon.svg": "ef3cc",
	"./icons/story-mode/revenue-stream/c_billable rate.svg": "6601",
	"./icons/story-mode/revenue-stream/c_occupancy rate.svg": "d52f",
	"./icons/story-mode/revenue-stream/c_product.svg": "478d",
	"./icons/story-mode/revenue-stream/c_recurring charges.svg": "5a06",
	"./icons/story-mode/revenue-stream/c_service.svg": "ea79",
	"./icons/story-mode/revenue-stream/w-billable-rate.svg": "581f",
	"./icons/story-mode/revenue-stream/w-occupancy-rate.svg": "b9bc",
	"./icons/story-mode/revenue-stream/w-product.svg": "9631",
	"./icons/story-mode/revenue-stream/w-recurring-charges.svg": "2a45",
	"./icons/story-mode/revenue-stream/w-service.svg": "eea0",
	"./icons/story-mode/revenue-stream/w_billable rate.svg": "6185",
	"./icons/story-mode/set-up-icon.svg": "15c6",
	"./icons/story-mode/validation-icon-old.svg": "75e8",
	"./icons/story-mode/validation-icon.svg": "536c",
	"./icons/story-mode/vertical.svg": "3bff",
	"./icons/story-mode/x.svg": "3825",
	"./icons/suggestion-close.svg": "1360",
	"./icons/suitcase-icon.svg": "b43c",
	"./icons/target-icon.svg": "dbb8",
	"./icons/tech-and-it-icon.svg": "0809",
	"./icons/top-right-banner.svg": "be8f",
	"./icons/track-results-icon.svg": "bd48",
	"./icons/transportation-and-storage-icon.svg": "9da8",
	"./icons/trashcan-icon.svg": "903a",
	"./icons/tutorials/concept-icon.svg": "b962",
	"./icons/tutorials/concept/concept-icon.svg": "546c",
	"./icons/tutorials/forecast/forecast-icon.svg": "69b7",
	"./icons/tutorials/research/research-icon.svg": "303d",
	"./icons/tutorials/set-up/set-up-icon.svg": "83be",
	"./icons/tutorials/validation/validation-icon.svg": "bd9e",
	"./icons/wave-arrow.svg": "7cb4",
	"./icons/wholesale-icon.svg": "fded6",
	"./icons/woman-icon.svg": "9cee",
	"./idea-icons/beer-icon.svg": "811a",
	"./idea-icons/butcher-icon.svg": "a6a1",
	"./idea-icons/croissant-icon.svg": "b20f",
	"./idea-icons/fish-icon.svg": "403c",
	"./idea-icons/ice-cream-stick-icon.svg": "2c28",
	"./idea-icons/pizza-icon.svg": "3809",
	"./idea-icons/steak-icon.svg": "07ce",
	"./illustrations/add-notes-latest.svg": "2cdb",
	"./illustrations/analysis.svg": "9103",
	"./illustrations/bus-with-suitcases.svg": "435e",
	"./illustrations/business-plan.svg": "87b6",
	"./illustrations/cancel-subscription.svg": "06cf3",
	"./illustrations/complete-step.svg": "a6f2",
	"./illustrations/completed-svg.svg": "6a73",
	"./illustrations/copy-note.svg": "8a20",
	"./illustrations/delete-note.svg": "ff01",
	"./illustrations/dialogs/fogg-logged-out-1.svg": "9788",
	"./illustrations/dialogs/fogg-order-completed.svg": "d12e",
	"./illustrations/dialogs/logout.svg": "7e19",
	"./illustrations/dialogs/thank-you-thumbs-up.svg": "87ac",
	"./illustrations/dialogs/thank-you.svg": "961f",
	"./illustrations/dialogs/upgrade-rocket.svg": "83f0",
	"./illustrations/dialogs/upgrade.svg": "35e0",
	"./illustrations/diary.svg": "22e0",
	"./illustrations/doors.svg": "ef7e",
	"./illustrations/export-financials.svg": "3647",
	"./illustrations/export.svg": "b2a7",
	"./illustrations/fogg-delete-confirmation.svg": "815a",
	"./illustrations/fogg-fatal-error-2.svg": "fe2e",
	"./illustrations/fogg-message-sent.svg": "21f0",
	"./illustrations/fogg-no-comments.svg": "8e72",
	"./illustrations/fogg-success-1.svg": "496a",
	"./illustrations/grade-a-purple.svg": "ff75",
	"./illustrations/grade-a.svg": "4bc5",
	"./illustrations/grey-mountains.svg": "02e4",
	"./illustrations/home.svg": "4e83",
	"./illustrations/home/business-guide.svg": "8369",
	"./illustrations/home/business-plan.svg": "ac04",
	"./illustrations/home/financial-plan.svg": "a56c",
	"./illustrations/home/financials_blue_250px.svg": "d50d",
	"./illustrations/home/idea-plan.svg": "6d61",
	"./illustrations/home/journal_blue_250px.svg": "97ef",
	"./illustrations/home/validation.svg": "d554",
	"./illustrations/home/validation_blue_250px.svg": "293f",
	"./illustrations/home/whiteboard.svg": "10ec",
	"./illustrations/idea-score-latest.svg": "8eb6",
	"./illustrations/idea-score-latest1.svg": "19e5",
	"./illustrations/idea_score.svg": "8e54",
	"./illustrations/journal-latest.svg": "6ed8",
	"./illustrations/journal.svg": "41a0b",
	"./illustrations/key.svg": "fca8",
	"./illustrations/learn-more-and-help/contact-us.svg": "787b",
	"./illustrations/learn-more-and-help/feedback.svg": "2f66",
	"./illustrations/learn-more-and-help/help-center.svg": "ad54",
	"./illustrations/learn-more-and-help/hire-expert.svg": "a65e",
	"./illustrations/lightbulb.svg": "2a57",
	"./illustrations/log-out.svg": "dcf8",
	"./illustrations/one-page-plan.svg": "cf88",
	"./illustrations/overview-latest.svg": "c075",
	"./illustrations/overview-new.svg": "daf9",
	"./illustrations/overview.svg": "d1a4",
	"./illustrations/payment-successful.svg": "450f",
	"./illustrations/payment/ai-requests-icon.svg": "c876",
	"./illustrations/payment/data-security.svg": "252a",
	"./illustrations/payment/wave-down.svg": "500a",
	"./illustrations/payment/wave-up.svg": "41e9",
	"./illustrations/pitch-deck.svg": "55c0",
	"./illustrations/plan.svg": "66d4",
	"./illustrations/relevant-example-latest.svg": "c748",
	"./illustrations/search-engine.svg": "7564",
	"./illustrations/search.svg": "f968",
	"./illustrations/select-idea/empty-state.svg": "07a6",
	"./illustrations/seo.svg": "02c2",
	"./illustrations/share-financials.svg": "39db",
	"./illustrations/space-ship-2.svg": "e2e5",
	"./illustrations/space-ship.svg": "3138",
	"./illustrations/step-completed.svg": "05d5",
	"./illustrations/story-mode-il.svg": "7d32",
	"./illustrations/story-mode-long.svg": "01db",
	"./illustrations/story-mode-long1.svg": "f742",
	"./illustrations/story-mode.svg": "4a2c",
	"./illustrations/swap.svg": "2838",
	"./illustrations/telescope.svg": "e9c3",
	"./illustrations/test-2.svg": "6c93",
	"./illustrations/test.svg": "e604",
	"./illustrations/the-plan-latest.svg": "35c9",
	"./illustrations/track-performance.svg": "2a84",
	"./illustrations/trash.svg": "782b",
	"./illustrations/truck-and-mountain.svg": "95d3",
	"./illustrations/validation/concept.svg": "789c",
	"./illustrations/validation/forecast.svg": "3262",
	"./illustrations/validation/research.svg": "94f4",
	"./illustrations/validation/setup.svg": "0179",
	"./illustrations/validation/whats-next.svg": "d66d",
	"./illustrations/what-head.svg": "ca5a",
	"./illustrations/why-head.svg": "bb82",
	"./logos/ideaBuddy-color.svg": "334c",
	"./logos/ideaBuddy-white.svg": "40e6",
	"./logos/logobeta.svg": "6db1",
	"./logos/sidebar-header-logo.svg": "7d18",
	"./onboarding/ai-icon.svg": "c772",
	"./onboarding/financialSettings.svg": "b89c",
	"./onboarding/full-onboarding.svg": "7723",
	"./onboarding/growth.svg": "965d",
	"./onboarding/hands.svg": "6ea3",
	"./onboarding/idea.svg": "3a5e",
	"./onboarding/launch.svg": "0c46",
	"./onboarding/onboarding-user-details-illustration.svg": "5084",
	"./onboarding/quick-start.svg": "af37",
	"./onboarding/template-icon.svg": "6899",
	"./payment/arrow-annual-blue.svg": "401d",
	"./payment/arrow-lifetime-blue.svg": "33f5",
	"./payment/arrow-monthly-blue.svg": "1471",
	"./payment/arrrow.svg": "278c",
	"./payment/dreamer.svg": "8937",
	"./payment/dreamer_new2.svg": "5c0d",
	"./payment/enterprise.svg": "9256",
	"./payment/founder.svg": "27aa",
	"./payment/founder_new.svg": "ea10",
	"./payment/img1.svg": "428a",
	"./payment/img2.svg": "a7da",
	"./payment/magic-wand-active.svg": "c86b",
	"./payment/magic-wand.svg": "55d9",
	"./payment/save40.svg": "0f63",
	"./placeholders/add-new-marketing-member-blue.svg": "f2d7",
	"./placeholders/add-new-marketing-member-yellow.svg": "678c",
	"./placeholders/cashFlow-md.svg": "05cb",
	"./placeholders/cashFlow-sm.svg": "1c05",
	"./placeholders/cashFlow-xl.svg": "d2cb",
	"./placeholders/graph-dummy-fp-overview.svg": "1f9d",
	"./placeholders/graph-dummy-md.svg": "2777",
	"./placeholders/graph-dummy-sm.svg": "8a35",
	"./placeholders/graph-dummy.svg": "a642",
	"./placeholders/pie-chart-placeholder.svg": "1140",
	"./placeholders/placeholder-horizontal-blue.svg": "abe9",
	"./placeholders/placeholder-horizontal-yellow.svg": "0be3",
	"./placeholders/profitAndLoss-md.svg": "e864",
	"./placeholders/profitAndLoss-sm.svg": "151e",
	"./placeholders/profitAndLoss-xl.svg": "ae01",
	"./placeholders/table-graph-fp-overview.svg": "7408",
	"./placeholders/table-graph-md.svg": "175c",
	"./placeholders/table-graph-sm.svg": "f550",
	"./placeholders/table-graph.svg": "5140",
	"./placeholders/timeline-graph-fp-overview.svg": "c04e8",
	"./placeholders/timeline-graph-md.svg": "6ab5",
	"./placeholders/timeline-graph-sm.svg": "da9e",
	"./placeholders/timeline-graph.svg": "6451",
	"./pricing/capterra-reviews/horn.svg": "f2de",
	"./pricing/faq/faq-waves.svg": "b77e",
	"./pricing/faq/yellow-lines.svg": "df67",
	"./pricing/idea-is-safe/shield.svg": "7e473",
	"./pricing/idea-is-safe/user-secret.svg": "035e",
	"./pricing/lifetime-deal/aiAssistanceIcon.svg": "c884",
	"./pricing/lifetime-deal/arrowRight.svg": "0b9e",
	"./pricing/lifetime-deal/backgroundLifetime.svg": "90f1",
	"./pricing/payment-guarantee/30-days-badge-money-back.svg": "b6e4",
	"./pricing/payment-guarantee/badge-money-back.svg": "cf54",
	"./pricing/payment-guarantee/card-american-express.svg": "3ccb",
	"./pricing/payment-guarantee/card-mastercard.svg": "de02",
	"./pricing/payment-guarantee/card-paypal.svg": "3d08",
	"./pricing/payment-guarantee/card-visa.svg": "a615",
	"./pricing/payment-guarantee/payment-paddle.svg": "a800",
	"./pricing/payment-guarantee/shield-check.svg": "22e4",
	"./pricing/plans/arrow-yellow.svg": "97a5",
	"./pricing/plans/arrow.svg": "67a3",
	"./pricing/plans/circle-check.svg": "b74b",
	"./pricing/plans/circle-xmark.svg": "d12f",
	"./pricing/plans/minus.svg": "9a24",
	"./pricing/plans/plus.svg": "5a84",
	"./pricing/plans/stars.svg": "519f",
	"./pricing/plans/waves.svg": "7197",
	"./pricing/plans/yellow-line.svg": "c148",
	"./pricing/plans/yellow-lines.svg": "69d5b",
	"./pricing/pricing-for-special-groups/nonprofit-icon.svg": "3a43",
	"./pricing/pricing-for-special-groups/school-icon.svg": "c0ef",
	"./pricing/pricing-for-special-groups/wave.svg": "ddd0",
	"./tutorial/tutorial-step-completed-modal.svg": "9fdf",
	"./util/arrow-down.svg": "77fc",
	"./util/arrow-left.svg": "35f4",
	"./util/arrow-right.svg": "eaa7",
	"./util/arrow-up-left.svg": "845f6",
	"./util/arrow-up.svg": "2928",
	"./util/completed-stamp.svg": "8ad3",
	"./video/play-button.svg": "6271"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";